import { render } from "./RbInformationCard.vue?vue&type=template&id=7dc261c4&scoped=true"
import script from "./RbInformationCard.vue?vue&type=script&lang=js"
export * from "./RbInformationCard.vue?vue&type=script&lang=js"

import "./RbInformationCard.vue?vue&type=style&index=0&id=7dc261c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc261c4"]])

export default __exports__